import { render, staticRenderFns } from "./DepreciateObject.vue?vue&type=template&id=58a3a6d8&scoped=true"
import script from "./DepreciateObject.vue?vue&type=script&lang=ts"
export * from "./DepreciateObject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a3a6d8",
  null
  
)

export default component.exports